<template>
  <div class="input-box">
    <div v-if="btnType === 'copy'" class="disabled url" id="url">
      {{ url }}
    </div>
    <input v-else type="text" v-model="value" />
    <button
      :disabled="btnType === 'send' && !isSend"
      :class="{ disabled: btnType === 'send' && !isSend }"
      @click="send"
    >
      {{ btnText }}
    </button>
  </div>
</template>

<script>
import { toast, checkMail } from '../../../lib/utils';
export default {
  props: {
    btnType: {
      type: String,
      default: 'copy', // copy - 复制  send - 发送
    },
    url: String,
  },
  data() {
    return {
      value: undefined,
    };
  },
  computed: {
    btnText() {
      if (this.btnType === 'copy') return '复制';
      return '发送';
    },
    isSend() {
      if (this.btnType === 'send') {
        if (this.value && this.value.trim()) return true;
        return false;
      }
    },
  },
  methods: {
    send() {
      if (this.btnType === 'copy') return this.$emit('copy', this.url); // TODO 直接让父组件调用复制url
      if (checkMail(this.value.trim())) {
        // TODO 发送邮箱到父组件
        this.$emit('send', this.value.trim());
      } else {
        toast('邮箱格式不正确');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.input-box {
  width: 100%;
  height: 38px;
  input,
  .url {
    display: inline-block;
    width: calc(100% - 64px);
    height: 38px;
    background: #fff;
    color: #999999;
    padding: 0 10px;
    outline: none;
    -webkit-appearance: none;
    border: 1px solid #dedede;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    &.disabled {
      background: #ededed;
      user-select: none;
    }
  }
  .url {
    line-height: 36px;
    overflow: hidden;
  }
  button {
    display: inline-block;
    width: 64px;
    height: 38px;
    color: #fff;
    font-size: 16px;
    background: #004fff;
    border: 0;
    border-radius: 0 4px 4px 0;
    margin: 0;
    padding: 0;
    outline: none; //消除默认点击蓝色边框效果
    vertical-align: top;
    &.disabled {
      background: rgba(0, 79, 255, 0.5);
    }
  }
}
</style>
